import { render } from "./logo.vue?vue&type=template&id=2f63d891&scoped=true"
import script from "./logo.vue?vue&type=script&lang=js"
export * from "./logo.vue?vue&type=script&lang=js"

import "./logo.vue?vue&type=style&index=0&id=2f63d891&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-2f63d891"

export default script